import { DecaCompanyRole } from '@okcargo-apps/shared-domain';

export const DECA_ROLE: Record<'CARRIER' | 'SHIPPER', DecaCompanyRole> = {
  CARRIER: 'carrier',
  SHIPPER: 'shipper',
};

export function isDecaRole(value: unknown): value is DecaCompanyRole {
  return value === DECA_ROLE.CARRIER || value === DECA_ROLE.SHIPPER;
}

export function otherDecaRole(role: DecaCompanyRole): DecaCompanyRole {
  return role === DECA_ROLE.CARRIER ? DECA_ROLE.SHIPPER : DECA_ROLE.CARRIER;
}
